export const onlyLetters = value => {
    return value
      .replace(/\d/g, '') 
  }